export const EDITOR_DRAWER_WIDTH = 380;
export const ENTITY_DRAWER_MAX_WIDTH = 720;
export const EDITOR_PROSE_WIDTH = 720;
